export const categories = [
  { slug: 'all', name: '全部', icon: 'ri-apps-2-line', description: '浏览全部漫画作品' },
  { slug: 'fantasy', name: '玄幻魔法', icon: 'ri-magic-line', description: '东方玄幻与西方魔法交织的奇幻世界' },
  { slug: 'xianxia', name: '仙侠修真', icon: 'ri-moon-line', description: '御剑飞行、渡劫飞升的修仙之旅' },
  { slug: 'urban', name: '都市异能', icon: 'ri-building-line', description: '现代都市中的超能力战斗' },
  { slug: 'scifi', name: '科幻未来', icon: 'ri-rocket-line', description: '高科技与未来世界的无限想象' },
  { slug: 'history', name: '历史古风', icon: 'ri-book-open-line', description: '穿越时空，重温历史经典' },
  { slug: 'romance', name: '恋爱甜宠', icon: 'ri-heart-line', description: '甜蜜浪漫的爱情故事' },
  { slug: 'comedy', name: '搞笑日常', icon: 'ri-emotion-laugh-line', description: '轻松搞笑的欢乐日常' },
];

export const comics = [
  {
    id: 1,
    title: '全职法师',
    author: '乱',
    category: 'fantasy',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20cover%20art%2C%20young%20male%20mage%20wielding%20magic%20in%20modern%20city%2C%20dynamic%20action%20pose%2C%20warm%20orange%20and%20golden%20magic%20effects%2C%20anime%20art%20style%2C%20clean%20simple%20background%2C%20professional%20illustration%2C%20high%20contrast%2C%20dramatic%20lighting&width=400&height=560&seq=comic-cover-01&orientation=portrait',
    description: '一觉醒来，世界巨变。曾经的普通学生莫凡，在魔法觉醒仪式上意外觉醒了全系魔法天赋，从此踏上了一条逆天改命的魔法之路。在这个充满妖兽与魔法的平行世界，他将如何用实力证明自己？',
    rating: 9.6,
    views: 32580000,
    chapters: 1280,
    status: '连载中',
    updateTime: '2026-08-05',
    tags: ['热门', '玄幻', '魔法', '热血'],
    featured: true,
    hot: true,
  },
  {
    id: 2,
    title: '斗破苍穹',
    author: '天蚕土豆',
    category: 'fantasy',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20cover%2C%20young%20warrior%20with%20flame%20aura%20in%20ancient%20Chinese%20martial%20world%2C%20epic%20fantasy%20style%2C%20warm%20fire%20colors%2C%20anime%20illustration%2C%20simple%20clean%20background%2C%20high%20quality%20art&width=400&height=560&seq=comic-cover-02&orientation=portrait',
    description: '天才少年萧炎在创造了家族空前绝后的修炼纪录后，突然成了废人。种种打击接踵而至，在他即将绝望之时，一缕灵魂从他手上的戒指里浮现。',
    rating: 9.5,
    views: 28900000,
    chapters: 860,
    status: '连载中',
    updateTime: '2026-08-04',
    tags: ['热门', '玄幻', '战斗'],
    featured: true,
    hot: true,
  },
  {
    id: 3,
    title: '凡人修仙传',
    author: '忘语',
    category: 'xianxia',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20cover%2C%20ordinary%20young%20man%20cultivator%20in%20traditional%20robes%20holding%20sword%2C%20mountainous%20landscape%20background%2C%20xianxia%20cultivation%20theme%2C%20anime%20art%20style%2C%20mystical%20atmosphere%2C%20soft%20golden%20light&width=400&height=560&seq=comic-cover-03&orientation=portrait',
    description: '一个普通的山村穷小子，偶然之下进入到一个江湖小门派。虽然资质平庸，但依靠自身努力和合理算计，最终修炼成仙。',
    rating: 9.7,
    views: 41200000,
    chapters: 1520,
    status: '已完结',
    updateTime: '2026-07-20',
    tags: ['经典', '仙侠', '修仙'],
    featured: true,
    hot: false,
  },
  {
    id: 4,
    title: '大王饶命',
    author: '会说话的肘子',
    category: 'urban',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20cover%2C%20high%20school%20student%20with%20supernatural%20powers%20in%20modern%20urban%20setting%2C%20comedy%20elements%2C%20warm%20lighting%2C%20anime%20illustration%20style%2C%20clean%20simple%20composition&width=400&height=560&seq=comic-cover-04&orientation=portrait',
    description: '灵气复苏时代，高三学生吕树意外觉醒了获取他人负面情绪转化成修为的能力，从此在吐槽和被吐槽的路上越走越远。',
    rating: 9.4,
    views: 25600000,
    chapters: 720,
    status: '已完结',
    updateTime: '2026-06-15',
    tags: ['都市', '异能', '搞笑'],
    featured: false,
    hot: true,
  },
  {
    id: 5,
    title: '星辰变',
    author: '我吃西红柿',
    category: 'xianxia',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20cover%2C%20young%20cultivator%20surrounded%20by%20stars%20and%20galaxy%20energy%2C%20cosmic%20cultivation%20theme%2C%20epic%20scale%2C%20anime%20art%20style%2C%20starry%20night%20background%2C%20mystical&width=400&height=560&seq=comic-cover-05&orientation=portrait',
    description: '天生无法修炼内力的秦羽，为了得到父亲的重视，毅然选择了修炼痛苦艰难的外功。春去秋来，时光如梭，这个倔强的少年终于突破了层层难关。',
    rating: 9.3,
    views: 19800000,
    chapters: 640,
    status: '连载中',
    updateTime: '2026-08-03',
    tags: ['仙侠', '星辰', '修炼'],
    featured: false,
    hot: false,
  },
  {
    id: 6,
    title: '完美世界',
    author: '辰东',
    category: 'fantasy',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20cover%2C%20young%20boy%20with%20ancient%20primitive%20clothing%20in%20wild%20fantasy%20world%2C%20giant%20beasts%20silhouettes%20in%20distance%2C%20epic%20adventure%2C%20anime%20style%2C%20warm%20earthy%20tones&width=400&height=560&seq=comic-cover-06&orientation=portrait',
    description: '一粒尘可填海，一根草斩尽日月星辰。弹指间天翻地覆。群雄并起，万族林立，诸圣争霸，乱天动地。问苍茫大地，谁主沉浮？',
    rating: 9.5,
    views: 35600000,
    chapters: 960,
    status: '连载中',
    updateTime: '2026-08-05',
    tags: ['热门', '玄幻', '史诗'],
    featured: true,
    hot: true,
  },
  {
    id: 7,
    title: '元尊',
    author: '天蚕土豆',
    category: 'fantasy',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20cover%2C%20young%20prince%20with%20mysterious%20markings%20and%20ancient%20energy%2C%20oriental%20fantasy%20palace%20background%2C%20regal%20atmosphere%2C%20anime%20art%20style%2C%20golden%20and%20warm%20tones&width=400&height=560&seq=comic-cover-07&orientation=portrait',
    description: '大周太子周元，身负圣龙气运，却遭人暗算，气运被夺。在绝境中他发现了逆转命运的契机，从此踏上了一条修炼逆天之路。',
    rating: 9.2,
    views: 18900000,
    chapters: 580,
    status: '已完结',
    updateTime: '2026-05-30',
    tags: ['玄幻', '热血', '逆袭'],
    featured: false,
    hot: false,
  },
  {
    id: 8,
    title: '一念永恒',
    author: '耳根',
    category: 'comedy',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20cover%2C%20funny%20young%20disciple%20in%20cultivation%20sect%20with%20mischievous%20expression%2C%20comedy%20martial%20arts%20theme%2C%20bright%20warm%20colors%2C%20anime%20illustration%2C%20humorous%20vibe&width=400&height=560&seq=comic-cover-08&orientation=portrait',
    description: '白小纯，一个怕死的修仙者。他的修仙之路，就是一条不断作死、不断怕死、不断搞笑的奇妙旅程。别人修仙为了长生，他修仙只是为了活下去。',
    rating: 9.4,
    views: 22300000,
    chapters: 820,
    status: '连载中',
    updateTime: '2026-08-04',
    tags: ['搞笑', '修仙', '轻松'],
    featured: false,
    hot: true,
  },
  {
    id: 9,
    title: '武动乾坤',
    author: '天蚕土豆',
    category: 'fantasy',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20cover%2C%20young%20martial%20artist%20with%20powerful%20energy%20aura%20in%20ancient%20Chinese%20setting%2C%20dynamic%20combat%20pose%2C%20epic%20wuxia%20style%2C%20anime%20art%2C%20warm%20golden%20lighting&width=400&height=560&seq=comic-cover-09&orientation=portrait',
    description: '修炼一途，乃窃阴阳、夺造化、转涅槃、握生死、掌轮回。武之极，破苍穹，动乾坤！少年林动，从青阳镇走出，一步步踏上巅峰。',
    rating: 9.3,
    views: 21500000,
    chapters: 700,
    status: '已完结',
    updateTime: '2026-04-18',
    tags: ['玄幻', '热血', '战斗'],
    featured: false,
    hot: false,
  },
  {
    id: 10,
    title: '大主宰',
    author: '天蚕土豆',
    category: 'fantasy',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20cover%2C%20young%20lord%20in%20magnificent%20fantasy%20world%20with%20spiritual%20energy%2C%20grand%20scale%2C%20oriental%20fantasy%2C%20anime%20illustration%20style%2C%20warm%20and%20golden%20atmosphere&width=400&height=560&seq=comic-cover-10&orientation=portrait',
    description: '大千世界，位面交汇，万族林立，群雄荟萃。一位位来自下位面的天之至尊，在这无尽世界中，演绎着令人向往的传奇，追求着那主宰之路。',
    rating: 9.1,
    views: 17800000,
    chapters: 620,
    status: '连载中',
    updateTime: '2026-08-02',
    tags: ['玄幻', '异界', '争霸'],
    featured: false,
    hot: false,
  },
  {
    id: 11,
    title: '绝世唐门',
    author: '唐家三少',
    category: 'fantasy',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20cover%2C%20young%20boy%20with%20spiritual%20beast%20companion%20in%20magic%20academy%20setting%2C%20fantasy%20school%20life%2C%20anime%20style%2C%20warm%20lighting%2C%20clean%20composition&width=400&height=560&seq=comic-cover-11&orientation=portrait',
    description: '一万年后，冰化了。曾经威震大陆的史莱克学院，如今变成了唐门。霍雨浩，一个身世神秘的少年，带着母亲的遗愿踏入了这片神奇的土地。',
    rating: 9.4,
    views: 26800000,
    chapters: 890,
    status: '已完结',
    updateTime: '2026-03-22',
    tags: ['经典', '学院', '魂兽'],
    featured: false,
    hot: false,
  },
  {
    id: 12,
    title: '雪中悍刀行',
    author: '烽火戏诸侯',
    category: 'history',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20cover%2C%20young%20swordsman%20in%20snowy%20ancient%20Chinese%20landscape%2C%20traditional%20robes%2C%20wuxia%20atmosphere%2C%20anime%20art%20style%2C%20cold%20yet%20warm%20tone%2C%20poetic%20composition&width=400&height=560&seq=comic-cover-12&orientation=portrait',
    description: '有个白狐儿脸，佩双刀绣冬春雷。有个缺门牙的老黄，牵马走江湖。北凉世子徐凤年，一人一马，走遍天下，看尽人间冷暖。',
    rating: 9.8,
    views: 38200000,
    chapters: 1040,
    status: '连载中',
    updateTime: '2026-08-05',
    tags: ['武侠', '古风', '经典'],
    featured: true,
    hot: true,
  },
];

export const articles = [
  {
    id: 1,
    comicId: 1,
    chapterTitle: '第1话 魔法觉醒',
    chapterNumber: 1,
    publishDate: '2026-01-15',
    views: 1280000,
    images: [
      'https://readdy.ai/api/search-image?query=Chinese%20manhua%20page%2C%20young%20student%20standing%20in%20magic%20awakening%20ceremony%20hall%2C%20glowing%20magic%20circle%20on%20ground%2C%20crowd%20watching%2C%20dramatic%20moment%2C%20black%20and%20white%20manga%20style%20with%20subtle%20warm%20tones%2C%20detailed%20lineart&width=900&height=1300&seq=manga-page-01-01&orientation=portrait',
      'https://readdy.ai/api/search-image?query=Chinese%20manhua%20page%2C%20boy%20surrounded%20by%20multiple%20elemental%20magic%20auras%20fire%20water%20wind%20earth%2C%20surprised%20expression%2C%20magic%20awakening%20moment%2C%20black%20and%20white%20manga%20style%2C%20dynamic%20effects&width=900&height=1300&seq=manga-page-01-02&orientation=portrait',
      'https://readdy.ai/api/search-image?query=Chinese%20manhua%20page%2C%20teacher%20explaining%20magic%20system%20to%20students%20in%20classroom%2C%20magic%20diagrams%20on%20board%2C%20black%20and%20white%20manga%20style%2C%20detailed%20background&width=900&height=1300&seq=manga-page-01-03&orientation=portrait',
      'https://readdy.ai/api/search-image?query=Chinese%20manhua%20page%2C%20protagonist%20practicing%20magic%20alone%20at%20night%2C%20small%20flame%20in%20palm%2C%20determined%20expression%2C%20dark%20campus%20background%2C%20black%20and%20white%20manga%20style&width=900&height=1300&seq=manga-page-01-04&orientation=portrait',
      'https://readdy.ai/api/search-image?query=Chinese%20manhua%20page%2C%20magic%20duel%20between%20two%20students%2C%20fireball%20versus%20ice%20shield%2C%20action%20scene%2C%20arena%20background%2C%20black%20and%20white%20manga%20style%2C%20dynamic%20composition&width=900&height=1300&seq=manga-page-01-05&orientation=portrait',
    ],
    prevId: null,
    nextId: 2,
  },
  {
    id: 2,
    comicId: 1,
    chapterTitle: '第2话 初次战斗',
    chapterNumber: 2,
    publishDate: '2026-01-22',
    views: 1150000,
    images: [
      'https://readdy.ai/api/search-image?query=Chinese%20manhua%20page%2C%20group%20of%20students%20entering%20dangerous%20forest%20for%20training%2C%20tall%20trees%2C%20mysterious%20atmosphere%2C%20black%20and%20white%20manga%20style&width=900&height=1300&seq=manga-page-02-01&orientation=portrait',
      'https://readdy.ai/api/search-image?query=Chinese%20manhua%20page%2C%20monster%20wolf%20creature%20emerging%20from%20bushes%2C%20students%20in%20defensive%20stance%2C%20tense%20moment%2C%20black%20and%20white%20manga%20style%2C%20detailed%20monster%20design&width=900&height=1300&seq=manga-page-02-02&orientation=portrait',
      'https://readdy.ai/api/search-image?query=Chinese%20manhua%20page%2C%20protagonist%20casting%20lightning%20magic%20at%20monster%2C%20bright%20flash%20effects%2C%20dynamic%20action%2C%20black%20and%20white%20manga%20style%2C%20speed%20lines&width=900&height=1300&seq=manga-page-02-03&orientation=portrait',
      'https://readdy.ai/api/search-image?query=Chinese%20manhua%20page%2C%20defeated%20monster%20on%20ground%2C%20exhausted%20students%20celebrating%20victory%2C%20relief%20expressions%2C%20forest%20clearing%2C%20black%20and%20white%20manga%20style&width=900&height=1300&seq=manga-page-02-04&orientation=portrait',
      'https://readdy.ai/api/search-image?query=Chinese%20manhua%20page%2C%20mysterious%20figure%20watching%20from%20distance%20in%20shadows%2C%20hint%20of%20larger%20plot%2C%20forest%20at%20dusk%2C%20black%20and%20white%20manga%20style%2C%20ominous%20atmosphere&width=900&height=1300&seq=manga-page-02-05&orientation=portrait',
    ],
    prevId: 1,
    nextId: 3,
  },
  {
    id: 3,
    comicId: 1,
    chapterTitle: '第3话 学院生活',
    chapterNumber: 3,
    publishDate: '2026-01-29',
    views: 1080000,
    images: [
      'https://readdy.ai/api/search-image?query=Chinese%20manhua%20page%2C%20magic%20academy%20campus%20wide%20shot%2C%20grand%20buildings%2C%20students%20walking%20around%2C%20beautiful%20architecture%2C%20black%20and%20white%20manga%20style&width=900&height=1300&seq=manga-page-03-01&orientation=portrait',
      'https://readdy.ai/api/search-image?query=Chinese%20manhua%20page%2C%20protagonist%20meeting%20new%20friends%20in%20dormitory%2C%20friendly%20conversation%2C%20various%20character%20designs%2C%20black%20and%20white%20manga%20style&width=900&height=1300&seq=manga-page-03-02&orientation=portrait',
      'https://readdy.ai/api/search-image?query=Chinese%20manhua%20page%2C%20magic%20theory%20class%2C%20teacher%20lecturing%2C%20students%20taking%20notes%2C%20magic%20books%2C%20black%20and%20white%20manga%20style%2C%20detailed%20classroom&width=900&height=1300&seq=manga-page-03-03&orientation=portrait',
      'https://readdy.ai/api/search-image?query=Chinese%20manhua%20page%2C%20rival%20student%20challenging%20protagonist%2C%20tense%20faceoff%2C%20crowd%20gathering%2C%20dramatic%20angles%2C%20black%20and%20white%20manga%20style&width=900&height=1300&seq=manga-page-03-04&orientation=portrait',
      'https://readdy.ai/api/search-image?query=Chinese%20manhua%20page%2C%20evening%20campus%20scene%2C%20protagonist%20looking%20at%20stars%2C%20reflective%20mood%2C%20beautiful%20night%20sky%2C%20black%20and%20white%20manga%20style%2C%20peaceful&width=900&height=1300&seq=manga-page-03-05&orientation=portrait',
    ],
    prevId: 2,
    nextId: 4,
  },
  {
    id: 4,
    comicId: 1,
    chapterTitle: '第4话 暗流涌动',
    chapterNumber: 4,
    publishDate: '2026-02-05',
    views: 1020000,
    images: [
      'https://readdy.ai/api/search-image?query=Chinese%20manhua%20page%2C%20secret%20meeting%20of%20shadowy%20figures%20in%20dark%20room%2C%20conspiracy%20atmosphere%2C%20black%20and%20white%20manga%20style%2C%20dramatic%20lighting&width=900&height=1300&seq=manga-page-04-01&orientation=portrait',
      'https://readdy.ai/api/search-image?query=Chinese%20manhua%20page%2C%20protagonist%20discovering%20hidden%20ancient%20magic%20book%20in%20library%2C%20dusty%20shelves%2C%20mysterious%20glow%2C%20black%20and%20white%20manga%20style&width=900&height=1300&seq=manga-page-04-02&orientation=portrait',
      'https://readdy.ai/api/search-image?query=Chinese%20manhua%20page%2C%20magic%20training%20intensifying%2C%20protagonist%20struggling%20with%20difficult%20spell%2C%20sweat%20and%20effort%2C%20black%20and%20white%20manga%20style%2C%20dynamic&width=900&height=1300&seq=manga-page-04-03&orientation=portrait',
      'https://readdy.ai/api/search-image?query=Chinese%20manhua%20page%2C%20mysterious%20transfer%20student%20arriving%20at%20academy%2C%20everyone%20staring%2C%20dramatic%20entrance%2C%20black%20and%20white%20manga%20style&width=900&height=1300&seq=manga-page-04-04&orientation=portrait',
      'https://readdy.ai/api/search-image?query=Chinese%20manhua%20page%2C%20cliffhanger%20ending%2C%20dark%20portal%20opening%20in%20sky%20above%20academy%2C%20students%20looking%20up%20in%20fear%2C%20black%20and%20white%20manga%20style%2C%20epic&width=900&height=1300&seq=manga-page-04-05&orientation=portrait',
    ],
    prevId: 3,
    nextId: null,
  },
];

export const chapterList = [
  { id: 1, comicId: 1, title: '第1话 魔法觉醒', date: '2026-01-15', views: 1280000 },
  { id: 2, comicId: 1, title: '第2话 初次战斗', date: '2026-01-22', views: 1150000 },
  { id: 3, comicId: 1, title: '第3话 学院生活', date: '2026-01-29', views: 1080000 },
  { id: 4, comicId: 1, title: '第4话 暗流涌动', date: '2026-02-05', views: 1020000 },
];